var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.dataTag,{tag:"component"},[(_vm.isLoading)?_c('p',{staticClass:"visually-hidden-focusable"},[_vm._v(" Contenuto in caricamento ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }